
      import Dialog from './dialog.vue'
      import type { App, Plugin } from 'vue'

      export const DialogPlugin: Plugin = {
        install(app: App) {
          app.component('Dialog', Dialog)
        },
      }
      export { Dialog }
      